export default __webpack_public_path__ + "static/user-42f278160fd15d3de30f409ddf503bcf.jpg";